import React, { useState } from "react";

import { Button } from "./ui/button";

const stepsData = [
  {
    question: "Which option best describes your investment experience?",
    options: [
      { label: "I am new to investing", value: "beginner" },
      { label: "I have some experience", value: "immediate" },
      { label: "I am an experienced investor", value: "advanced" },
    ],
  },
  {
    question: "How would you describe your risk tolerance?",
    options: [
      { label: "Low (Prefer stable, low-risk investments)", value: "low" },
      {
        label:
          "Moderate  (Willing to take some risks for potential higher returns)",
        value: "moderate",
      },
      {
        label: "High (Comfortable with significant risk for high returns)",
        value: "high",
      },
    ],
  },
  {
    question: "What is your primary goal for investing?",
    options: [
      { label: "Preserve my capital", value: "Preserve my capital" },
      { label: "Generate steady income", value: "Generate steady income" },
      {
        label: "Achieve substantial growth",
        value: "Achieve substantial growth",
      },
    ],
  },
  {
    question: "How long do you plan to keep your investments?",
    options: [
      { label: "Less than 2 years", value: "Less than 2 years" },
      { label: "Between 2 and 5 years", value: "Between 2 and 5 years" },
      { label: "More than 5 years", value: "More than 5 years" },
    ],
  },
  {
    question: "What is your main concern when investing?",
    options: [
      { label: "Losing money", value: "Losing money" },
      {
        label: "Not achieving high enough returns",
        value: "Not achieving high enough returns",
      },
      {
        label: "Volatility in investment value",
        value: "Volatility in investment value",
      },
    ],
  },
];

export default function InvestQuestionaire({ onComplete }) {
  const [currentStep, setCurrentStep] = useState(0);
  const [answers, setAnswers] = useState({});
  const [disableButton, setDisableButton] = useState(true);

  const handleChange = (value) => {
    setDisableButton(false);
    setAnswers((prev) => ({ ...prev, [currentStep]: value }));
  };

  const handleNext = () => {
    setDisableButton(true);
    if (currentStep < stepsData.length - 1) {
      setCurrentStep((prev) => prev + 1);
    } else {
      onComplete?.(answers);
    }
  };

  const { question, options } = stepsData[currentStep];

  return (
    <div className="p-4">
      <h2 className="text-2xl font-semibold mb-10 text-brand-primary">
        {question}
      </h2>
      {options.map((option) => (
        <label className="flex items-center space-x-3 mb-4 cursor-pointer">
          <input
            type="radio"
            name={`step-${currentStep}`}
            value={option.value}
            checked={answers[currentStep] === option.value}
            onChange={() => handleChange(option.value)}
            className="w-8 h-8 accent-brand-primary border-purple-600"
          />
          <span className="text-sm text-gray-600">{option.label}</span>
        </label>
      ))}

      <Button
        onClick={handleNext}
        disabled={disableButton}
        type="primary"
        className="px-32 py-3 mt-10 bg-gradient-to-r flex justify-self-center from-purple-500 to-rose-600 text-white py-3 rounded-full text-sm font-medium"
      >
        Next
      </Button>
    </div>
  );
}
